"use strict";

exports.__esModule = true;
exports.DashboardTagContext = void 0;
var _Utils = require("../../../Utils");
var _DashboardTagController = require("./DashboardTagController");
/**
 * Provides a rest api to consumers.
 * @component
 */
var DashboardTagContext = exports.DashboardTagContext = (0, _Utils.createEnhancedContext)({
  propName: "dashboardTags",
  defaultController: _DashboardTagController.DashboardTagController
});